module.exports = __webpack_public_path__ + "img/financial.f41d298c.png";